import { useCallback, useMemo, useState } from 'react'

import { useUser } from '@/modules/auth'
import { loadUploadGuideSeenAt, persistUploadGuideSeenAt } from './prefs'

// Until the user is known the guide counts as seen, so it never flashes open.
export const useUploadGuideSeen = () => {
  const userId = useUser()?.id ?? null
  const [finishedFor, setFinishedFor] = useState<string | null>(null)
  const seenBefore = useMemo(
    () => userId === null || loadUploadGuideSeenAt(userId) !== null,
    [userId],
  )

  const markSeen = useCallback(() => {
    if (userId === null) return
    persistUploadGuideSeenAt(userId, new Date().toISOString())
    setFinishedFor(userId)
  }, [userId])

  return { seen: seenBefore || finishedFor === userId, markSeen }
}
